export default "__VITE_ASSET__BZKGHwEk__"